import { render, staticRenderFns } from "./InboxList.vue?vue&type=template&id=712fc227&scoped=true&"
import script from "./InboxList.vue?vue&type=script&lang=js&"
export * from "./InboxList.vue?vue&type=script&lang=js&"
import style0 from "./InboxList.vue?vue&type=style&index=0&id=712fc227&lang=scss&scoped=true&"
import style1 from "./InboxList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712fc227",
  null
  
)

export default component.exports